import { BULKINSERT_RECEIVE, BULKINSERT_ERROR } from '../Actions/CartBulkinsert.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    errors: {},
    result:{},
}

export const cartbulkinsert = (state = defaultState, action) => {
    const { type,payload} = action;
    switch (type) {
        case BULKINSERT_RECEIVE:
            return {
                ...state,
                result:payload.result
            }
        case BULKINSERT_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}